import { render } from "./templates/uploader.html?vue&type=template&id=0846db78&external"
import script from "./script/uploader.js?vue&type=script&lang=js&external"
export * from "./script/uploader.js?vue&type=script&lang=js&external"

const cssModules = {}
import style0 from "./stylesheets/index.scss?vue&type=style&index=0&lang=scss&module=true&external"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__